<template>
  <div v-if="statistics" class="sip-statistics" style="width: 100%;">
    <v-card style="border-radius: 16px; width: 100%;" class="pa-6 mt-4">
      <v-card-title class="pb-4">
        <span class="text-h6">Активированные устройства (SIP: {{ statistics.login }})</span>
        <v-spacer></v-spacer>
        <span class="text-body-2 grey--text">Период: {{ statistics.period_days }} {{ getPeriodText(statistics.period_days) }}</span>
      </v-card-title>

      <v-divider class="mb-4"></v-divider>

      <div class="mb-6">
        <h3 class="mb-3 text-subtitle-1 font-weight-bold">
          Устройства ({{ statistics.devices ? statistics.devices.length : 0 }})
        </h3>
        <v-data-table
          v-if="statistics.devices && statistics.devices.length > 0"
          :headers="deviceHeadersWithToken"
          :items="statistics.devices"
          :items-per-page="5"
          class="elevation-0"
          :hide-default-footer="statistics.devices.length <= 5"
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 50],
            'showFirstLastPage': true,
          }"
        >
          <template v-slot:item.uuid="{ item }">
            <span class="text-caption font-family-monospace">{{ truncateUuid(item.uuid) }}</span>
          </template>
          <template v-slot:item.updated_at="{ item }">
            <span>{{ ruDateFormat(item.updated_at, false, true) }}</span>
          </template>
          <template v-slot:item.token="{ item }">
            <div v-if="item.token" class="d-flex align-center">
              <span class="text-caption font-family-monospace mr-2">{{ truncateToken(item.token) }}</span>
              <v-icon
                small
                class="cursor-pointer"
                @click="copyToken(item.token)"
              >
                mdi-content-copy
              </v-icon>
            </div>
            <span v-else class="grey--text text-caption">—</span>
          </template>
        </v-data-table>
        <v-alert v-else type="info" outlined class="mt-2">
          Устройства не найдены
        </v-alert>
      </div>

      <v-divider class="mb-4"></v-divider>

      <div>
        <h3 class="mb-3 text-subtitle-1 font-weight-bold">
          Push-уведомления ({{ statistics.pushes ? statistics.pushes.length : 0 }})
        </h3>
        <v-data-table
          v-if="statistics.pushes && statistics.pushes.length > 0"
          :headers="pushHeaders"
          :items="statistics.pushes"
          :items-per-page="5"
          class="elevation-0"
          :hide-default-footer="statistics.pushes.length <= 5"
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 50],
            'showFirstLastPage': true,
          }"
        >
          <template v-slot:item.timestamp="{ item }">
            <span>{{ ruDateFormat(item.timestamp, false, true) }}</span>
          </template>
          <template v-slot:item.sent="{ item }">
            <v-chip
              :color="item.sent ? 'success' : 'error'"
              small
              dark
            >
              {{ item.sent ? 'Успешно' : 'Не отправлено' }}
            </v-chip>
          </template>
          <template v-slot:item.device="{ item }">
            <span>{{ item.device || 'Не указано' }}</span>
          </template>
          <template v-slot:item.reason="{ item }">
            <span v-if="item.reason" class="text-caption">{{ item.reason }}</span>
            <span v-else class="grey--text text-caption">—</span>
          </template>
          <template v-slot:item.from="{ item }">
            <span v-if="item.from" class="text-caption">{{ item.from }}</span>
            <span v-else class="grey--text text-caption">—</span>
          </template>
        </v-data-table>
        <v-alert v-else type="info" outlined class="mt-2">
          Push-уведомления не найдены
        </v-alert>
      </div>
    </v-card>
  </div>
</template>

<script>
import ruDateFormat from '@/mixins/ruDateFormat';

export default {
  name: 'SipCacheStatistics',
  mixins: [ruDateFormat],
  props: {
    statistics: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      lastCopiedToken: null,
      deviceHeaders: [
        {
          text: 'UUID',
          value: 'uuid',
          sortable: false,
        },
        {
          text: 'User Agent',
          value: 'user_agent',
          sortable: false,
        },
        {
          text: 'Обновлено',
          value: 'updated_at',
          sortable: false,
        },
        {
          text: 'Токен',
          value: 'token',
          sortable: false,
        },
      ],
      pushHeaders: [
        {
          text: 'Время',
          value: 'timestamp',
          sortable: false,
        },
        {
          text: 'Устройство',
          value: 'device',
          sortable: false,
        },
        {
          text: 'Статус',
          value: 'sent',
          sortable: false,
        },
        {
          text: 'Причина',
          value: 'reason',
          sortable: false,
        },
        {
          text: 'От',
          value: 'from',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    deviceHeadersWithToken () {
      const hasToken = this.statistics?.devices?.some(device => device.token);
      if (hasToken) {
        return this.deviceHeaders;
      }
      return this.deviceHeaders.filter(header => header.value !== 'token');
    },
  },
  methods: {
    truncateUuid (uuid) {
      if (!uuid) return '';
      return uuid.length > 20 ? uuid.substring(0, 20) + '...' : uuid;
    },
    truncateToken (token) {
      if (!token) return '';
      return token.length > 15 ? token.substring(0, 15) + '...' : token;
    },
    async copyToken (token) {
      if (this.lastCopiedToken === token) {
        return;
      }
      try {
        await navigator.clipboard.writeText(token);
        this.lastCopiedToken = token;
        this.$flash_success('Токен скопирован!');
      } catch (err) {
        this.$flash_danger('Не удалось скопировать токен');
      }
    },
    getPeriodText (days) {
      if (days === 1) return 'день';
      if (days >= 2 && days <= 4) return 'дня';
      return 'дней';
    },
  },
};
</script>

<style lang="scss" scoped>
.sip-statistics {
  .font-family-monospace {
    font-family: 'Courier New', monospace;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-pointer:hover {
    opacity: 0.7;
  }
}
</style>
